import React from "react";

import { FormControl } from "react-bootstrap";

export default class TextAreaWrapper extends React.PureComponent {
  render() {
    return <FormControl {...this.props} componentClass="textarea" />;
  }
}
